import axios from 'axios';
import api from './endpoints';

export default {
  list(args = {}) {
    return axios.get(api.NEWS, {
      params: {
        page: args.page ? args.page : 1,
        size: args.size ? args.size : 3,
        category: args.category ? args.category : 'news'
      }
    })
      .then((result) => result.data);
  },
  mostViewed(args = {}) {
    return axios.get(api.NEWS, {
      params: {
        page: args.page ? args.page : 1,
        size: args.size ? args.size : 3,
        category: args.category ? args.category : 'news',
        order: 'best'
      }
    })
      .then((result) => result.data);
  },
  featured(args) {
    let page = args.page ? args.page : 1;
    let size = args.size ? args.size : 4;

    return axios.get(api.NEWS, {
      params: {
        page: page,
        size: size,
        category: args.category ? args.category : 'news',
        order: 'featured',
        offset: args.offset != undefined ? args.offset : 1,
      }
    }).then((result) => {

        return result.data;
      });
  },
  latestFeatured() {
    return axios.get(api.NEWS, {
      params: {
        page: 1,
        size: 1,
        offset: 0,
        order: 'featured',
        category: args.category ? args.category : 'news',
      }
    })
      .then((result) => result.data);
  },
  detail(args) {
    return axios.get(api.NEWS + '/' + args.slug)
      .then((result) => result.data);
  },
  create(args) {
    return axios.post(api.SECURE_NEWS, args).then((result) => result.data);
  },
  edit(args) {
    return axios.put(api.SECURE_NEWS + '/' + args.slug, args).then((result) => result.data);
  },
  unpublished(args) {
    let page = args.page ? args.page : 1;
    let size = args.size ? args.size : 10;
    return axios.get(api.SECURE_NEWS, {
      params: {
        page: page,
        size: size
      }
    }).then((result) => result.data);
  },
  unpublishedDetail(args) {
    return axios.get(api.SECURE_NEWS + '/' + args.slug, args).then((result) => result.data);
  }
};
